import type { RouteRecord } from "vite-react-ssg";
import { Navigate } from "react-router-dom";
import RootLayout from "./RootLayout";
import OAuthConsent from "./pages/OAuthConsent";
import OAuthSignIn from "./pages/OAuthSignIn";


import Index from "./pages/Index";
import About from "./pages/About";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import { PREBUILT_DB_SLUGS } from "@/lib/db-posts";

import Contact from "./pages/Contact";
import DeepseekCoder from "./pages/DeepseekCoder";
import DeepseekStock from "./pages/DeepseekStock";
import DeepseekR1 from "./pages/DeepseekR1";
import DeepLearningAI from "./pages/DeepLearningAI";
import VibeCoding from "./pages/VibeCoding";
import ChromeExtensionUninstall from "./pages/ChromeExtensionUninstall";
import ChromeExtensionUpdate from "./pages/ChromeExtensionUpdate";
import AIChat from "./pages/AIChat";
import WhatIsDeepseekAI from "./pages/WhatIsDeepseekAI";
import DeepseekR2Challenges from "./pages/BlogPosts/DeepseekR2Challenges";
import WhatIsDeepLearningAI from "./pages/BlogPosts/WhatIsDeepLearningAI";
import WhatIsDeepSeek from "./pages/BlogPosts/WhatIsDeepSeek";
import DeepseekV31Silent from "./pages/BlogPosts/DeepseekV31Silent";
import Llama4VsDeepseek from "./pages/BlogPosts/Llama4VsDeepseek";
import DeepseekR2 from "./pages/BlogPosts/DeepseekR2";
import DeepseekTerminus from "./pages/BlogPosts/DeepseekTerminus";
import DeepseekOCR from "./pages/BlogPosts/DeepseekOCR";
import DeepseekChenDeliAI from "./pages/BlogPosts/DeepseekChenDeliAI";
import DeepseekMathV2 from "./pages/BlogPosts/DeepseekMathV2";
import ReasoningEraGeminiDeepseek from "./pages/BlogPosts/ReasoningEraGeminiDeepseek";
import DeepseekGuide2026 from "./pages/BlogPosts/DeepseekGuide2026";
import DeepseekMHC from "./pages/BlogPosts/DeepseekMHC";
import DeepseekEngram from "./pages/BlogPosts/DeepseekEngram";
import DeepseekV4NextMove from "./pages/BlogPosts/DeepseekV4NextMove";
import ClaudeOpus48VsDeepseekV4 from "./pages/BlogPosts/ClaudeOpus48VsDeepseekV4";
import Deepseek50BillionFunding from "./pages/BlogPosts/Deepseek50BillionFunding";
import Deepseek74BillionBizarreDeal from "./pages/BlogPosts/Deepseek74BillionBizarreDeal";
import DeepseekV4BetterThan99Percent from "./pages/BlogPosts/DeepseekV4BetterThan99Percent";
import DeepseekDSpark from "./pages/BlogPosts/DeepseekDSpark";
import DeepseekDSparkInside from "./pages/BlogPosts/DeepseekDSparkInside";
import DeepseekOwnAIChip from "./pages/BlogPosts/DeepseekOwnAIChip";
import DeepseekV4GASurgePricing from "./pages/BlogPosts/DeepseekV4GASurgePricing";
import DeepseekChatReasonerRetiredBilling from "./pages/BlogPosts/DeepseekChatReasonerRetiredBilling";
import DeepseekV4FlashGA from "./pages/BlogPosts/DeepseekV4FlashGA";
import DeepseekReasonix from "./pages/BlogPosts/DeepseekReasonix";
import DeepseekHarness from "./pages/BlogPosts/DeepseekHarness";
import DeepseekV5Rumors from "./pages/BlogPosts/DeepseekV5Rumors";
import DeepseekV41FlashVsGpt6Astra from "./pages/BlogPosts/DeepseekV41FlashVsGpt6Astra";
import DeepseekVision from "./pages/BlogPosts/DeepseekVision";
import LeakCatlDeepseekInvestor from "./pages/BlogPosts/LeakCatlDeepseekInvestor";
import DeepseekAgiFundingRound from "./pages/BlogPosts/DeepseekAgiFundingRound";
import DeepseekV4ProPriceCutPermanent from "./pages/BlogPosts/DeepseekV4ProPriceCutPermanent";
import DeepseekV41FlashBeta from "./pages/BlogPosts/DeepseekV41FlashBeta";
import DeepseekV41FlashGA from "./pages/BlogPosts/DeepseekV41FlashGA";
import DeepseekV41Flash1017 from "./pages/BlogPosts/DeepseekV41Flash1017";
import DeepseekHuaweiAscendCluster from "./pages/BlogPosts/DeepseekHuaweiAscendCluster";
import DeepseekHiring150Engineers from "./pages/BlogPosts/DeepseekHiring150Engineers";
import DeepseekAI from "./pages/DeepseekAI";
import DeepseekAPI from "./pages/DeepseekAPI";
import DeepseekVsChatGPT from "./pages/DeepseekVsChatGPT";
import DeepseekVsClaude from "./pages/DeepseekVsClaude";
import DeepseekVsGemini from "./pages/DeepseekVsGemini";
import DeepseekVsPerplexity from "./pages/DeepseekVsPerplexity";
import DeepseekVsLlama from "./pages/DeepseekVsLlama";
import DeepseekVsMistral from "./pages/DeepseekVsMistral";
import DeepseekVsStepfun from "./pages/DeepseekVsStepfun";
import DeepseekV4 from "./pages/DeepseekV4";
import DeepseekV4FlashReview from "./pages/DeepseekV4FlashReview";
import DeepseekV4CompressedAttention from "./pages/BlogPosts/DeepseekV4CompressedAttention";
import DeepseekV4Unveiled from "./pages/BlogPosts/DeepseekV4Unveiled";
import IsDeepseekSafe from "./pages/IsDeepseekSafe";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Pricing from "./pages/Pricing";
import Docs from "./pages/Docs";
import ChatPage from "./pages/ChatPage";
import Login from "./pages/Login";
import SeoReport from "./pages/SeoReport";
import DeepseekDeutsch from "./pages/DeepseekDeutsch";
import DeepseekCanada from "./pages/DeepseekCanada";
import DeepseekUSA from "./pages/DeepseekUSA";
import DeepseekUK from "./pages/DeepseekUK";
import DeepseekCorrectSpelling from "./pages/DeepseekCorrectSpelling";
import NotFound from "./pages/NotFound";

export const routes: RouteRecord[] = [
  // MCP OAuth surfaces — deliberately outside RootLayout (no site chrome) and
  // under a dot-directory so they are never indexed or linked as content.
  { path: "/.lovable/oauth/consent", element: <OAuthConsent /> },
  { path: "/.lovable/oauth/signin", element: <OAuthSignIn /> },

  {
    path: "/",
    element: <RootLayout />,
    children: [
      { index: true, element: <Index /> },
      { path: "chat", element: <ChatPage /> },
      { path: "seo-report", element: <SeoReport /> },
      { path: "pricing", element: <Pricing /> },
      { path: "docs", element: <Docs /> },
      { path: "about", element: <About /> },
      { path: "solutions", element: <Navigate to="/" replace /> },
      { path: "blog", element: <Blog /> },
      // Dynamic slug route. Slugs with a dedicated component are listed below;
      // the remaining ones come from the weekly auto-generated posts in the
      // database, snapshotted at build time so they prerender to real HTML.
      {
        path: "blog/:slug",
        element: <BlogPost />,
        getStaticPaths: () => PREBUILT_DB_SLUGS.map((slug) => `/blog/${slug}`),
      },

      { path: "blog/vibe-coding", element: <VibeCoding /> },
      { path: "blog/ai-chat", element: <AIChat /> },
      { path: "blog/deepseek-r2-challenges", element: <DeepseekR2Challenges /> },
      { path: "blog/what-is-deep-learning-ai", element: <WhatIsDeepLearningAI /> },
      { path: "blog/what-is-deep-seek", element: <WhatIsDeepSeek /> },
      // Removed: written as a fake DeepSeek press release. Kept as a redirect.
      { path: "blog/deepseek-v31", element: <Navigate to="/blog/deepseek-v31-silent-revolution" replace /> },
      { path: "blog/deepseek-v31-silent-revolution", element: <DeepseekV31Silent /> },
      { path: "blog/deepseek-terminus-upgrade", element: <DeepseekTerminus /> },
      { path: "blog/deepseek-ocr-context-compression", element: <DeepseekOCR /> },
      { path: "blog/deepseek-chen-deli-ai-humanity-warning", element: <DeepseekChenDeliAI /> },
      { path: "blog/deepseek-math-v2", element: <DeepseekMathV2 /> },
      { path: "blog/reasoning-era-gemini-3-deepseek", element: <ReasoningEraGeminiDeepseek /> },
      { path: "blog/deepseek-guide-2026", element: <DeepseekGuide2026 /> },
      { path: "blog/deepseek-mhc-manifold-constrained-hyper-connections", element: <DeepseekMHC /> },
      { path: "blog/deepseek-engram-v4-architecture", element: <DeepseekEngram /> },
      { path: "blog/deepseek-v4-next-move", element: <DeepseekV4NextMove /> },
      { path: "blog/claude-opus-4-8-vs-deepseek-v4", element: <ClaudeOpus48VsDeepseekV4 /> },
      { path: "blog/deepseek-50-billion-funding-round", element: <Deepseek50BillionFunding /> },
      { path: "blog/deepseek-raises-7-4-billion-bizarre-deal", element: <Deepseek74BillionBizarreDeal /> },
      { path: "blog/how-to-use-deepseek-v4-better-than-99-percent", element: <DeepseekV4BetterThan99Percent /> },
      { path: "blog/deepseek-dspark-speculative-decoding", element: <DeepseekDSpark /> },
      { path: "blog/inside-deepseek-dspark-lossless-inference", element: <DeepseekDSparkInside /> },
      { path: "blog/deepseek-own-ai-chip-inference-silicon", element: <DeepseekOwnAIChip /> },
      { path: "blog/deepseek-v4-ga-surge-pricing-migration", element: <DeepseekV4GASurgePricing /> },
      { path: "blog/deepseek-chat-reasoner-retired-billing-impact", element: <DeepseekChatReasonerRetiredBilling /> },
      { path: "blog/deepseek-v4-flash-ga-agent-benchmarks", element: <DeepseekV4FlashGA /> },
      { path: "blog/deepseek-reasonix-coding-agent-cli", element: <DeepseekReasonix /> },
      { path: "blog/deepseek-harness-open-source-claude-code-alternative", element: <DeepseekHarness /> },
      { path: "blog/deepseek-v5-release-date-rumors", element: <DeepseekV5Rumors /> },
      { path: "blog/deepseek-v41-flash-vs-gpt6-astra-four-builds", element: <DeepseekV41FlashVsGpt6Astra /> },
      { path: "blog/deepseek-vision-api-guide", element: <DeepseekVision /> },
      { path: "blog/leak-catl-deepseek-investor", element: <LeakCatlDeepseekInvestor /> },
      { path: "blog/deepseek-agi-10-billion-funding-round", element: <DeepseekAgiFundingRound /> },
      { path: "blog/deepseek-v4-pro-api-price-cut-permanent", element: <DeepseekV4ProPriceCutPermanent /> },
      { path: "blog/deepseek-v41-flash-beta-native-multimodal", element: <DeepseekV41FlashBeta /> },
      { path: "blog/deepseek-v41-flash-generally-available", element: <DeepseekV41FlashGA /> },
      { path: "blog/deepseek-v41-flash-1017-deepinfer-review", element: <DeepseekV41Flash1017 /> },
      { path: "blog/deepseek-huawei-ascend-160000-chip-cluster", element: <DeepseekHuaweiAscendCluster /> },
      { path: "blog/deepseek-hiring-150-engineers-systems-shift", element: <DeepseekHiring150Engineers /> },
      { path: "blog/what-is-deepseek-ai", element: <WhatIsDeepseekAI /> },
      { path: "blog/llama-4-vs-deepseek", element: <Llama4VsDeepseek /> },
      { path: "blog/deepseek-v4-flash-review", element: <Navigate to="/deepseek-v4-flash-review" replace /> },
      { path: "blog/deepseek-v4-compressed-attention", element: <DeepseekV4CompressedAttention /> },
      { path: "blog/deepseek-v4-unveiled-1-6-trillion-parameters", element: <DeepseekV4Unveiled /> },
      { path: "blog/deepseek-r2-ai-model-launch-2025", element: <DeepseekR2 /> },
      { path: "contact", element: <Contact /> },
      { path: "login", element: <Login /> },
      { path: "deepseek-login", element: <Navigate to="/login" replace /> },
      { path: "deepseek-pricing", element: <Navigate to="/pricing" replace /> },
      { path: "deepseek-stock", element: <DeepseekStock /> },
      { path: "deepseek-coder", element: <DeepseekCoder /> },
      { path: "deepseek-r1", element: <DeepseekR1 /> },
      { path: "deep-learning-ai", element: <DeepLearningAI /> },
      { path: "what-is-deepseek-ai", element: <Navigate to="/blog/what-is-deepseek-ai" replace /> },
      { path: "deepseek-ai", element: <DeepseekAI /> },
      { path: "deepseek-api", element: <DeepseekAPI /> },
      { path: "deepseek-vs-chatgpt", element: <DeepseekVsChatGPT /> },
      { path: "deepseek-vs-claude", element: <DeepseekVsClaude /> },
      { path: "deepseek-vs-gemini", element: <DeepseekVsGemini /> },
      { path: "deepseek-vs-perplexity", element: <DeepseekVsPerplexity /> },
      { path: "deepseek-vs-llama", element: <DeepseekVsLlama /> },
      { path: "deepseek-vs-mistral", element: <DeepseekVsMistral /> },
      { path: "deepseek-vs-stepfun", element: <DeepseekVsStepfun /> },
      { path: "deepseek-v4", element: <DeepseekV4 /> },
      { path: "deepseek-v4-flash-review", element: <DeepseekV4FlashReview /> },
      { path: "is-deepseek-safe", element: <IsDeepseekSafe /> },
      { path: "privacy-policy", element: <PrivacyPolicy /> },
      { path: "chrome-extension-uninstall", element: <ChromeExtensionUninstall /> },
      { path: "chrome-extension-update", element: <ChromeExtensionUpdate /> },
      { path: "deepseek-deutsch", element: <DeepseekDeutsch /> },
      { path: "deepseek-canada", element: <DeepseekCanada /> },
      { path: "deepseek-usa", element: <DeepseekUSA /> },
      { path: "deepseek-uk", element: <DeepseekUK /> },
      { path: "deepseek-correct-spelling", element: <DeepseekCorrectSpelling /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];
